import React from 'react'
import {Table} from 'react-bootstrap'
import { Link } from 'react-router';
import {t} from '../../helpers/translate'
import {isSuperAdmin} from '../../helpers/access'

class ClaimComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  renderClaims (){
    return (
      <tbody>
        {this.props.claims.map(
          (claim, index) => {
            return (
              <tr key={index}>
                {this.renderLinkCell(claim)}
                {this.renderTableCell(claim.policy_number)}
                {this.renderTableCell(claim.created_at)}
              </tr>
            )
          }
        )}
      </tbody>
    )
  }

  renderTableCell (value) {
    return <td>{value}</td>
  }

  getLink(id){
    return {
      state: {claim_id: id},
      pathname: `/claim`
    };
  }

  renderLinkCell (value) {
    return <td>
      <Link className='btn button-primary' to={this.getLink(value.id)}
      > {value.claim_id} </Link></td>
  }

  render() {
    const tableHead = [t('Submission ID'), t('Policy #'), t('Date Submitted')];

    return isSuperAdmin('ingle') && <div>
      {this.props.claims.length > 0 &&
        <Table striped condensed hover id='noteTable'>
          <thead>
            <tr>
            {tableHead.map((title, index) => <th key={index}>{title}</th>)}
            </tr>
          </thead>
          {this.renderClaims()}
        </Table>
      }
    </div>
  }
}
ClaimComponent.displayName = 'ClaimComponent';
export default ClaimComponent;


// WEBPACK FOOTER //
// ./src/components/common/ClaimComponent.js